
import React, { useEffect, useState } from "react";
import { Baby } from "lucide-react";
import { motion } from "framer-motion";
import { calculateAge } from "@/utils/ageCalculator";
import { getBabyProfileSync } from "@/utils/babyProfile";
import { isBabyUnderThreeYears } from "@/utils/ageCalculator";
import { useLanguage } from "@/contexts/language";

const BabyAnimation = () => {
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [babyName, setBabyName] = useState<string | null>(null);
  const [babyAge, setBabyAge] = useState<string | null>(null);
  const { language } = useLanguage();

  useEffect(() => {
    const profile = getBabyProfileSync();
    
    if (profile && profile.birthday) {
      const isLessThan3YearsOld = isBabyUnderThreeYears(profile.birthday);
      setShouldAnimate(isLessThan3YearsOld);
      setBabyName(profile.name);
      
      // Calculate age in the current language
      const formattedAge = calculateAge(new Date(profile.birthday), language);
      setBabyAge(formattedAge);
    }
  }, [language]); // Re-run when language changes

  if (!shouldAnimate) return null;

  return (
    <div className="absolute bottom-10 left-10 z-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ 
          opacity: 1, 
          y: [0, -15, 0],
          rotate: [-5, 5, -5]
        }}
        transition={{ 
          y: { 
            repeat: Infinity, 
            duration: 2,
            ease: "easeInOut"
          },
          rotate: {
            repeat: Infinity,
            duration: 2.5,
            ease: "easeInOut"
          }
        }}
        className="flex flex-col items-center"
      >
        <div className="bg-primary/10 p-4 rounded-full mb-2">
          <Baby className="h-10 w-10 text-primary" />
        </div>
        <motion.div 
          initial={{ scale: 0.9 }}
          animate={{ scale: [0.9, 1.1, 0.9] }}
          transition={{ 
            repeat: Infinity, 
            duration: 2 
          }}
          className="bg-white px-3 py-1 rounded-lg shadow-md"
        >
          <p className="text-sm font-medium text-primary">
            {babyName ? `${babyName}: ${babyAge}` : babyAge}
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default BabyAnimation;
